import { buildCrud } from './clients';

export default (client) => ({
	...buildCrud(client, 'processes'),
	nodes: buildCrud(client, 'process-nodes'),
	links: buildCrud(client, 'process-links'),
	getAvailableWorklows: (id) => client.get(`/processes/${id}/available-workflows/`),
	publish: (id) => client.get(`/processes/${id}/publish/`),
});
